/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import TableHead from './TableHead'
import Contract from './Contract'
import groupBy from 'lodash.groupby'

const Results = ({data=[],...rest}) => {
  const grouped = groupBy(data,'gen_contractnumber_tb');
  const rows = Object.keys(grouped).map((row,i)=>{
    return <Contract key={`contract-row-${i}`} data={grouped[row]} {...rest} />
  });
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <TableHead/>
      {rows}
    </div>
  )
};

Results.propTypes = {};
Results.defaultProps = {};

export default Results;


// WEBPACK FOOTER //
// ./src/components/Results.jsx